import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import { AppConfig } from '../config/app.config';
import { IReturnObject } from '../shared/return-object.model';
import { StatusEnum } from '../shared/enums.model';
import { ApprovalFlowBE } from './shared/dashboard.model';

@Injectable()
export class DashBoardService {
    constructor(private config: AppConfig, private http: Http) { }

    private apiUrl: string = this.config.get('apiUrl') + 'DashBoard';

    getListForValidationInfo(userId: string): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/getListForValidationInfo/?userId=${userId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getPrelPruInstructionsList(userId: string): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetPrelPruInstructionsList/?userId=${userId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getListFor(status: StatusEnum, userId: string, supplierNumber: string, extendedSupplierNumber: string): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetListFor/?status=${status}&userId=${userId}&supplierNumber=${supplierNumber}&extendedSupplierNumber=${extendedSupplierNumber}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getWaitingForApprovalList(userId: string): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetWaitingForApprovalList/?userId=${userId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getSentToSupplierList(supplierNo: string, extendedSupplierNo: string): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetSentToSupplierList/?supplierNo=${supplierNo}&extendedSupplierNo=${extendedSupplierNo}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getAdminSentToSupplierList(userId: string, isPE: boolean): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetAdminSentToSupplierList/?userId=${userId}&isPE=${isPE}`)
       .map((response: Response) => <IReturnObject>response.json());
    }

    getSentToMultipleList(userId: string): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetSentToMultipleList/?userId=${userId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }


    GetPruUserList(): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetPruUserList`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    GetUsersforPruId(pruidvalue: string): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetUsersforPruId/?pruidvalue=${pruidvalue}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    GetPartPruUpdates(): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetPartPruUpdates`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    GetPruList(): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetPruList`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getSelectedPruChanges(pruId: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetPruUpdates/?pruId=${pruId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }


    updateFlowStatus(updData: ApprovalFlowBE): Observable<IReturnObject> {
        let body = JSON.stringify(updData);
        let options = this.getUpdateOptions(this.getUpdateHeader());

        return this.http.post(`${this.apiUrl}/UpdateFlowStatus`, body, options)
            .map((response: Response) => <IReturnObject>response.json());
    }

    updateSentToMultipleFlowStatus(updData: ApprovalFlowBE): Observable<IReturnObject> {
        let body = JSON.stringify(updData);
        let options = this.getUpdateOptions(this.getUpdateHeader());

        return this.http.post(`${this.apiUrl}/UpdateSentToMultipleFlowStatus`, body, options)
            .map((response: Response) => <IReturnObject>response.json());
    }

    private getUpdateHeader(): Headers {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        return headers;
    }

    private getUpdateOptions(headers: Headers): RequestOptions {
        return new RequestOptions({ headers: headers });
    }

    getHistoryFor(instructionId: number, supplierNo: string): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetHistoryFor/?instructionId=${instructionId}&supplierNo=${supplierNo}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getSupplierInfoExpiryDate(supplierNo: string, extendedSupplierNo: string): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetSupplierInfoExpiryDate/?supplierNo=${supplierNo}&extendedSupplierNo=${extendedSupplierNo}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

}



// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/app/dashboard/dashboard.service.ts